import React from 'react';
import { setConfig } from 'react-hot-loader';
import { HashRouter, Switch, Route } from 'react-router-dom';
import loadable from '@loadable/component';
import PrivatedRoute from 'leo-components/PrivatedRoute';

const Home = loadable(() =>
  import(/* webpackChunkName: "example" */ '../pages/Home/index')
);
const Audit = loadable(() =>
  import(/* webpackChunkName: "example" */ '../pages/Audit/index')
);
const RightManager = loadable(() =>
  import(/* webpackChunkName: "example" */ '../pages/RightManager/index')
);
// 汇总页面
const Summary = loadable(() =>
  import(/* webpackChunkName: "example" */ '../pages/Summary/index')
);
// 尽调项目
const DueDiligence = loadable(() =>
  import(/* webpackChunkName: "example" */ '../pages/DueDiligence/index')
);
const BatchManagement = loadable(() =>
  import(/* webpackChunkName: "example" */ '../pages/BatchManagement/index')
);
const InspectionAttachment = loadable(() =>
  import(/* webpackChunkName: "example" */ '../pages/InspectionAttachment/index')
);
const ExternalGroupManagement = loadable(() =>
  import(/* webpackChunkName: "example" */ '../pages/ExternalGroupManagement/index')
);


// const ProjectDetail = loadable(() =>
//   import(/* webpackChunkName: "example" */ '../pages/Audit/views/ProjectDetail/index')
// );

class Router extends React.Component {
  shouldComponentUpdate(prevProps) {
    return this.props.hasLogin !== prevProps.hasLogin;
  }
  render() {
    const { hasLogin, authorities } = this.props;
    let privatedRoutes = [];

    if (hasLogin) {
      privatedRoutes = [
        <PrivatedRoute
          key="audit"
          path="/audit"
          authorities={authorities}
          component={(props) => <Audit {...props} />}
        />,
        <PrivatedRoute
          key="user-manager"
          path="/user-manager"
          authorities={authorities}
          component={(props) => <RightManager {...props} />}
        />,
        <PrivatedRoute
          key="summary-inspection"
          path="/summary"
          authorities={authorities}
          component={(props) => <Summary {...props} />}
        />,
        <PrivatedRoute
          key="due-diligence"
          path="/due-diligence"
          authorities={authorities}
          component={(props) => <DueDiligence {...props} />}
        />,
        <PrivatedRoute
          key="batch-management"
          path="/batch-management"
          authorities={authorities}
          component={(props) => <BatchManagement {...props} />}
        />,
        <PrivatedRoute
          key="inspection-attachment"
          path="/inspection-attachment"
          authorities={authorities}
          component={(props) => <InspectionAttachment {...props} />}
        />,
        <PrivatedRoute
          key="external-group-management"
          path="/external-group-management"
          authorities={authorities}
          component={(props) => <ExternalGroupManagement {...props} />}
        />,
      ];
    }

    return (
      <HashRouter>
        <Switch>
          <Route path="/" exact component={(props) => <Home {...props} />} />
          {privatedRoutes}
          <Route path="*" exact component={(props) => <Home {...props} />} />
        </Switch>
      </HashRouter>
    );
  }
}


setConfig({
  showReactDomPatchNotification: false,
});

export default Router;
